import React from "react";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ModalStyles } from "components/Common/styles.js";
import { languageService } from "../../Language/language.service";
import PropTypes from "prop-types";
import { MyButton } from "components/Common/Forms/formsMiscItems";
import { CommonModalStyle, ButtonStyle } from "style/basic/commonControls";
import { themeService } from "theme/service/activeTheme.service";

const CommonModalStateless = (props) => {
  const { isOpen, headerText, className, modalStyle, footerContent, children } = props;

  return (
    <Modal
      contentClassName={themeService({
        default: className,
        retro: "retroModal " + className,
        electric: "electricModal " + className,
      })}
      isOpen={isOpen}
      style={modalStyle || { maxWidth: "50vw" }}
    >
      <ModalHeader style={(ModalStyles.modalTitleStyle, themeService(CommonModalStyle.header))}>{languageService(headerText)}</ModalHeader>
      <ModalBody className="scrollbar" style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.body))}>
        {children}
      </ModalBody>
      <ModalFooter style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.footer))}>{footerContent}</ModalFooter>
    </Modal>
  );
};

export default CommonModalStateless;



// WEBPACK FOOTER //
// ./src/components/Common/CommonModalStateless.jsx